



import React, { useState, useEffect } from "react";
import { FaTrash, FaPlus, FaSpinner, FaUpload, FaTimes, FaEdit, FaSearch, FaDownload, FaSort, FaFilter, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Modal from "react-modal";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import {
    uploadDish,
    getDishById,
    updateDish,
    updateCategory,
    deleteDish,
    deleteCategory
} from "../../Servicefile/Menuapiservice";
import {
    getValidImageUrl,
    fetchFoodMenuDataAPI,
    addFoodCategoryAPI,
} from "../../Servicefile/Menuapiservice";

Modal.setAppElement("#root");

// Inline loader hook 
const useInlineLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };
    return { showLoader, hideLoader, loading, fadeOut };
};

export default function Foodcustomizemenu() {
    const [isQuickModal, setIsQuickModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [dishes, setDishes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [filteredDishes, setFilteredDishes] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [hoveredDelete, setHoveredDelete] = useState(null);
    const [hoveredEdit, setHoveredEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("all");
    const [sortOrder, setSortOrder] = useState("asc");
    const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();
    const [quickForm, setQuickForm] = useState({
        catageory: "",
        image: null,
    });

    const [isDetailModal, setIsDetailModal] = useState(false);
    const [detailForm, setDetailForm] = useState({
        id: "",
        catageoryId: "",
        dishName: "",
        image: null,
    });

    const [selectedCategoryName, setSelectedCategoryName] = useState("");
    const [scrollProgress, setScrollProgress] = useState(0);

    const [isEditCategoryModal, setIsEditCategoryModal] = useState(false);
    const [editCategoryForm, setEditCategoryForm] = useState({
        catageoryId: "",
        catageoryName: "",
        image: null,
        currentImage: ""
    });

    const [isEditDishModal, setIsEditDishModal] = useState(false);
    const [editDishForm, setEditDishForm] = useState({
        id: "",
        name: "",
        image: null,
        currentImage: "",
        catageoryId: ""
    });

    // Handle scroll progress
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollPercent = docHeight > 0 ? scrollTop / docHeight : 0;
            setScrollProgress(scrollPercent);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Filter and search dishes
    useEffect(() => {
        let filtered = [...dishes];

        // Filter by category
        if (selectedCategory !== "all") {
            filtered = filtered.filter(dish => String(dish.catageoryId) === String(selectedCategory));
        }

        // Search by dish name
        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase().trim();
            filtered = filtered.filter(dish =>
                dish.name.toLowerCase().includes(term)
            );
        }

        // Sort by name
        if (sortOrder === "asc") {
            filtered.sort((a, b) => a.name.localeCompare(b.name));
        } else {
            filtered.sort((a, b) => b.name.localeCompare(a.name));
        }

        setFilteredDishes(filtered);
    }, [dishes, searchTerm, selectedCategory, sortOrder]);

    // Handle adding new dish to a category
    const handleAddClick = (category) => {
        setIsDetailModal(true);
        setDetailForm({
            id: "",
            catageoryId: category.catageoryId,
            dishName: "",
            image: null,
        });
        setSelectedCategoryName(category.catageoryName);
    };

    const handleDetailSave = async () => {
        try {
            const authToken = localStorage.getItem("authToken");

            if (!detailForm.catageoryId) {
                alert("Please select category");
                return;
            }

            if (!detailForm.dishName?.trim()) {
                alert("Please enter dish name");
                return;
            }

            // if (!detailForm.image) {
            //     alert("Please select image");
            //     return;
            // }

            const formData = new FormData();
            formData.append("categoryId", new Blob([String(detailForm.catageoryId)], { type: "application/json" }));
            formData.append("dish", new Blob([JSON.stringify({ name: detailForm.dishName.trim() })], { type: "application/json" }));
            formData.append("image", detailForm.image);

            showLoader();
            await uploadDish(formData, authToken);
            alert("✅ Dish added successfully");
            setIsDetailModal(false);
            setDetailForm({ id: "", catageoryId: "", dishName: "", image: null });
            setSelectedCategoryName("");
            fetchData();
        } catch (err) {
            console.error("Dish save error:", err);
            alert("❌ " + (err.response?.data?.message || err.message));
        } finally {
            hideLoader();
        }
    };

    // GET Dish by ID - for editing
    const handleEditDishClick = async (dishId) => {
        try {
            showLoader();
            const authToken = localStorage.getItem("authToken");
            const dishData = await getDishById(dishId, authToken);
            setEditDishForm({
                id: dishData.id,
                name: dishData.name,
                image: null,
                currentImage: dishData.image || "",
                catageoryId: dishData.category?.catageoryId || ""
            });
            setIsEditDishModal(true);
        } catch (err) {
            console.error("Error fetching dish:", err);
            alert("Failed to load dish details: " + err.message);
        } finally {
            hideLoader();
        }
    };

    // PUT - Update Dish
    const handleUpdateDish = async () => {
        if (!editDishForm.name.trim()) {
            alert("Please enter dish name!");
            return;
        }

        try {
            setIsSaving(true);
            showLoader();
            const authToken = localStorage.getItem("authToken");

            if (!authToken) {
                alert("Please login again");
                return;
            }

            const dish = dishes.find(d => d.id === parseInt(editDishForm.id));
            const category = categories.find(cat => cat.catageoryId === dish?.catageoryId);

            const dishObj = {
                id: editDishForm.id,
                name: editDishForm.name.trim(),
                image: editDishForm.currentImage,
                category: {
                    catageoryId: category?.catageoryId || "",
                    catageoryName: category?.catageoryName || "",
                    image: category?.image || ""
                }
            };

            const formData = new FormData();
            formData.append("categoryId", editDishForm.catageoryId);
            formData.append("dish", new Blob([JSON.stringify(dishObj)], { type: "application/json" }), "dish.json");

            if (editDishForm.image) {
                formData.append("image", editDishForm.image);
            }

            await updateDish(editDishForm.id, formData, authToken);
            alert("✅ Dish updated successfully!");
            setIsEditDishModal(false);
            setEditDishForm({ id: "", name: "", image: null, currentImage: "", catageoryId: "" });
            fetchData();
        } catch (err) {
            console.error("Dish update error:", err);
            alert("❌ Failed to update dish: " + (err.response?.data?.message || err.message));
        } finally {
            setIsSaving(false);
            hideLoader();
        }
    };

    // Handle edit category click
    const handleEditCategoryClick = (category) => {
        setEditCategoryForm({
            catageoryId: category.catageoryId,
            catageoryName: category.catageoryName,
            image: null,
            currentImage: category.image || ""
        });
        setIsEditCategoryModal(true);
    };

    // PUT - Update Category
    const handleUpdateCategory = async () => {
        if (!editCategoryForm.catageoryName.trim()) {
            alert("Please enter category name!");
            return;
        }

        try {
            setIsLoading(true);
            showLoader();
            const authToken = localStorage.getItem("authToken");

            if (!authToken) {
                alert("Please login again");
                return;
            }

            const categoryObj = {
                catageoryId: editCategoryForm.catageoryId,
                catageoryName: editCategoryForm.catageoryName.trim(),
                image: editCategoryForm.currentImage
            };

            const formData = new FormData();
            formData.append("category", new Blob([JSON.stringify(categoryObj)], { type: "application/json" }));

            if (editCategoryForm.image) {
                formData.append("categoryImg", editCategoryForm.image);
            }

            await updateCategory(editCategoryForm.catageoryId, formData, authToken);
            alert("✅ Category updated successfully!");
            setIsEditCategoryModal(false);
            setEditCategoryForm({ catageoryId: "", catageoryName: "", image: null, currentImage: "" });
            fetchData();
        } catch (err) {
            console.error("Category update error:", err);
            alert("❌ Category update failed: " + (err.response?.data?.message || err.message));
        } finally {
            setIsLoading(false);
            hideLoader();
        }
    };

    // DELETE - Category
    const handleDeleteCategory = async (categoryId) => {
        if (!window.confirm("Are you sure you want to delete this category? All dishes in this category will also be deleted!")) return;

        try {
            setIsSaving(true);
            showLoader();
            const authToken = localStorage.getItem("authToken");

            if (!authToken) {
                alert("No auth token found. Please login.");
                return;
            }

            const dishesInCategory = dishes.filter(dish => dish.catageoryId === categoryId);

            for (const dish of dishesInCategory) {
                await deleteDish(dish.id, authToken);
            }

            await deleteCategory(categoryId, authToken);
            alert("✅ Category deleted successfully!");
            fetchData();
        } catch (err) {
            console.error("Delete category error:", err);
            alert("❌ Delete failed: " + (err.response?.data?.message || err.message));
        } finally {
            setIsSaving(false);
            hideLoader();
        }
    };

    // DELETE - Dish
    const handleDeleteDish = async (id) => {
        if (!window.confirm("Are you sure you want to delete this dish?")) return;

        try {
            setIsSaving(true);
            showLoader();
            const authToken = localStorage.getItem("authToken");

            if (!authToken) {
                alert("No auth token found. Please login.");
                return;
            }

            await deleteDish(id, authToken);

            const dishRow = document.querySelector(`[data-dish-id="${id}"]`);
            if (dishRow) {
                dishRow.style.opacity = "0";
                dishRow.style.transform = "translateX(-20px)";
                setTimeout(() => {
                    dishRow.style.display = "none";
                }, 300);
            }

            setTimeout(() => {
                alert("Dish deleted successfully!");
                fetchData();
            }, 300);
        } catch (err) {
            console.error("Failed to delete dish:", err);
            if (err.response?.status === 404) {
                console.warn(`Dish ${id} not found, might have been already deleted`);
                const dishRow = document.querySelector(`[data-dish-id="${id}"]`);
                if (dishRow) {
                    dishRow.style.opacity = "0";
                    dishRow.style.transform = "translateX(-20px)";
                    setTimeout(() => {
                        dishRow.style.display = "none";
                    }, 300);
                }
                alert("Dish deleted successfully!");
                fetchData();
                return;
            }
            alert("Failed to delete dish: " + (err.response?.data?.message || err.message));
        } finally {
            setIsSaving(false);
            hideLoader();
        }
    };

    const handleDetailChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image") {
            setDetailForm(prev => ({ ...prev, image: files[0] || null }));
        } else {
            setDetailForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleEditDishChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image") {
            setEditDishForm(prev => ({ ...prev, image: files[0] || null }));
        } else {
            setEditDishForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleEditCategoryChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image") {
            setEditCategoryForm(prev => ({ ...prev, image: files[0] || null }));
        } else {
            setEditCategoryForm(prev => ({ ...prev, [name]: value }));
        }
    };

    // Fetch categories and dishes
    const fetchData = async () => {
        setLoading(true);
        setError(null);

        try {
            showLoader();
            const result = await fetchFoodMenuDataAPI();
            setCategories(result.categories);
            setDishes(result.dishes);
            setFilteredDishes(result.dishes);
        } catch (err) {
            console.error("Error fetching data:", err);
            setError(`Failed to load menu data: ${err.message}. Please try again.`);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Handle adding new category
    const handleQuickSave = async () => {
        if (!quickForm.catageory.trim()) {
            alert("Enter category name!");
            return;
        }

        try {
            setIsLoading(true);
            showLoader();

            const formData = new FormData();

            // ✅ Category JSON object - image field set to empty string (or null)
            const categoryObj = {
                catageoryId: 0,
                catageoryName: quickForm.catageory.trim(),
                image: quickForm.image ? null : null // Always empty string - API will handle it
            };

            formData.append("category", new Blob([JSON.stringify(categoryObj)], { type: "application/json" }));

            // ✅ Always append categoryImg - send file if exists, else send empty
            if (quickForm.image) {
                formData.append("categoryImg", quickForm.image);
            } else {
                // Send empty value as per your API docs
                formData.append("categoryImg", null);
            }

            await addFoodCategoryAPI(quickForm);
            alert("✅ Category added successfully!");
            setIsQuickModal(false);
            setQuickForm({ catageory: "", image: null });
            fetchData();
        } catch (err) {
            console.error("Category add error:", err);
            alert("❌ Category add failed: " + err.message);
        } finally {
            setIsLoading(false);
            hideLoader();
        }
    };

    const handleQuickChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image" && files && files[0]) {
            setQuickForm(prev => ({ ...prev, image: files[0] }));
        } else {
            setQuickForm(prev => ({ ...prev, [name]: value }));
        }
    };

    // Handle exporting to Excel
    const handleExport = () => {
        if (dishes.length === 0) {
            alert("No dishes to export!");
            return;
        }

        const exportData = dishes.map(dish => ({
            "Dish ID": dish.id,
            "Dish Name": dish.name,
            "Category ID": dish.catageoryId,
            "Category Name": categories.find(c => c.catageoryId === dish.catageoryId)?.catageoryName || "Unknown"
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Food Menu");
        XLSX.writeFile(wb, "food_menu.xlsx");
    };

    // Group dishes by category for display
    const getDishesByCategory = (categoryId) => {
        if (!categoryId) return [];
        const catIdStr = String(categoryId);
        return filteredDishes.filter(dish => {
            if (!dish.catageoryId) return false;
            return String(dish.catageoryId) === catIdStr;
        });
    };

    const handleRetry = () => {
        fetchData();
    };

    // Helper function to render image or placeholder with hover effect
    const renderImage = (url, alt) => {
        const imageUrl = getValidImageUrl(url);

        if (imageUrl) {
            return (
                <div className="image-container" style={{ position: 'relative', display: 'inline-block' }}>
                    <img
                        src={imageUrl}
                        alt={alt}
                        className="dish-image"
                        style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "2px solid #e0e0e0",
                            transition: "all 0.3s ease",
                            cursor: "pointer"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'scale(1.1)';
                            e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'scale(1)';
                            e.target.style.boxShadow = 'none';
                        }}
                        onClick={() => {
                            const modal = document.createElement('div');
                            modal.style.position = 'fixed';
                            modal.style.top = '0';
                            modal.style.left = '0';
                            modal.style.width = '100%';
                            modal.style.height = '100%';
                            modal.style.backgroundColor = 'rgba(0,0,0,0.9)';
                            modal.style.display = 'flex';
                            modal.style.alignItems = 'center';
                            modal.style.justifyContent = 'center';
                            modal.style.zIndex = '9999';
                            modal.style.opacity = '0';
                            modal.style.transition = 'opacity 0.3s ease';

                            const img = document.createElement('img');
                            img.src = imageUrl;
                            img.alt = alt;
                            img.style.maxWidth = '90%';
                            img.style.maxHeight = '90%';
                            img.style.borderRadius = '10px';
                            img.style.transform = 'scale(0.9)';
                            img.style.transition = 'transform 0.3s ease';

                            modal.appendChild(img);
                            document.body.appendChild(modal);

                            setTimeout(() => {
                                modal.style.opacity = '1';
                                img.style.transform = 'scale(1)';
                            }, 10);

                            modal.onclick = () => {
                                modal.style.opacity = '0';
                                img.style.transform = 'scale(0.9)';
                                setTimeout(() => {
                                    document.body.removeChild(modal);
                                }, 300);
                            };
                        }}
                        onError={(e) => {
                            console.error("Image failed to load:", imageUrl);
                            e.target.style.display = 'none';
                            const parent = e.target.parentElement;
                            if (parent) {
                                parent.innerHTML = `
                                    <div style="width: 50px; height: 50px; background: linear-gradient(135deg, #e66d33 0%, #e66d33 100%); border-radius: 8px; border: 2px solid #e0e0e0; display: flex; align-items: center; justify-content: center; color: white; font-size: 10px; font-weight: bold; cursor: default;">
                                        No Image
                                    </div>
                                `;
                            }
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div style={{ width: "50px", height: "50px", background: "linear-gradient(135deg, #e66d33 0%, #e66d33 100%)", borderRadius: "8px", border: "2px solid #e0e0e0", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "10px", fontWeight: "bold", cursor: "default" }}>
                    No Image
                </div>
            );
        }
    };

    return (
        <div className="food-menu-container" style={{
            // marginTop: "100px", 
            padding: "5px",
            maxWidth: "1400px",
            marginLeft: "auto",
            marginRight: "auto",
            position: "relative"
        }}>
            {/* Global Loader */}
            {globalLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 999999,
                    transition: 'opacity 0.4s ease',
                    fontFamily: 'Arial, sans-serif',
                    opacity: fadeOut ? 0 : 1,
                    pointerEvents: fadeOut ? 'none' : 'auto'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: '2rem',
                            fontWeight: 900,
                            letterSpacing: '6px',
                            marginBottom: '30px',
                        }}>
                            {"MAAMAAS".split("").map((l, i) => (
                                <span
                                    key={i}
                                    style={{
                                        display: 'inline-block',
                                        opacity: 0,
                                        transform: 'translateY(30px)',
                                        animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
                                        color: '#e50914',
                                    }}
                                >
                                    {l}
                                </span>
                            ))}
                        </div>

                        <div style={{
                            width: '280px',
                            height: '4px',
                            background: 'rgba(255,255,255,0.2)',
                            overflow: 'hidden',
                            margin: '0 auto',
                        }}>
                            <div style={{
                                width: '40%',
                                height: '100%',
                                background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
                                animation: 'progress 1.8s infinite',
                            }}></div>
                        </div>

                        <div style={{
                            marginTop: '20px',
                            color: '#aaa',
                            fontSize: '14px',
                        }}>
                            Preparing your experience...
                        </div>
                    </div>
                </div>
            )}

            {/* Scroll Progress Bar */}
            <div style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: `${scrollProgress * 100}%`,
                height: "3px",
                background: "linear-gradient(90deg, #e66d33, #ff6b6b)",
                zIndex: "1000",
                transition: "width 0.1s ease"
            }}></div>




            {/* Search and Filter Bar */}
            <div className="search-filter-bar" style={{
                display: "flex",
                gap: "15px",
                flexWrap: "wrap",
                marginBottom: "15px",
              
                borderRadius: "12px",
                alignItems: "center"
            }}>
                <div className="search-wrapper" style={{
                    flex: "1",
                    minWidth: "200px",
                    position: "relative"
                }}>
                    <FaSearch style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#999"
                    }} />
                    <input
                        type="text"
                        placeholder="Search dishes..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            border: "2px solid #e0e0e0",
                            borderRadius: "8px",
                            fontSize: "14px",
                            transition: "all 0.3s ease",
                            outline: "none"
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = "#e66d33";
                            e.target.style.boxShadow = "0 0 0 3px rgba(230, 109, 51, 0.1)";
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = "#e0e0e0";
                            e.target.style.boxShadow = "none";
                        }}
                    />
                </div>
                <button
                    className="btn-primary"
                    onClick={() => setIsQuickModal(true)}
                    style={{
                        padding: "12px 24px",
                        background: "linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontSize: "15px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        boxShadow: "0 4px 15px rgba(230, 109, 51, 0.3)",
                        transition: "all 0.3s ease"
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 6px 25px rgba(230, 109, 51, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px 15px rgba(230, 109, 51, 0.3)";
                    }}
                >
                    <FaPlus /> Add Category
                </button>
                <button
                    className="btn-export"
                    onClick={handleExport}
                    disabled={dishes.length === 0}
                    style={{
                        padding: "12px 24px",
                        background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: "10px",
                        cursor: dishes.length === 0 ? "not-allowed" : "pointer",
                        fontSize: "15px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        opacity: dishes.length === 0 ? 0.6 : 1,
                        boxShadow: dishes.length === 0 ? "none" : "0 4px 15px rgba(40, 167, 69, 0.3)",
                        transition: "all 0.3s ease"
                    }}
                    onMouseEnter={(e) => {
                        if (dishes.length > 0) {
                            e.target.style.transform = "translateY(-2px)";
                            e.target.style.boxShadow = "0 6px 25px rgba(40, 167, 69, 0.4)";
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (dishes.length > 0) {
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow = "0 4px 15px rgba(40, 167, 69, 0.3)";
                        }
                    }}
                >
                    <FaDownload /> Export
                </button>

                <div className="filter-wrapper" style={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    alignItems: "center"
                }}>
                    {/* <FaFilter style={{ color: "#666" }} /> */}
                    <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        style={{
                            padding: "10px 35px 10px 15px",
                            border: "2px solid #e0e0e0",
                            borderRadius: "8px",
                            fontSize: "14px",
                            background: "white",
                            cursor: "pointer",
                            outline: "none",
                            transition: "all 0.3s ease",
                            appearance: "none",
                            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E\")",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "right 12px center"
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = "#e66d33";
                            e.target.style.boxShadow = "0 0 0 3px rgba(230, 109, 51, 0.1)";
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = "#e0e0e0";
                            e.target.style.boxShadow = "none";
                        }}
                    >
                        <option value="all">All Categories</option>
                        {categories.map(category => (
                            <option key={category.catageoryId} value={category.catageoryId}>
                                {category.catageoryName}
                            </option>
                        ))}
                    </select>

                    <button
                        onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
                        style={{
                            padding: "10px 15px",
                            background: "#f8f9fa",
                            border: "2px solid #e0e0e0",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            transition: "all 0.3s ease"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.borderColor = "#e66d33";
                            e.target.style.background = "#fff5f0";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.borderColor = "#e0e0e0";
                            e.target.style.background = "#f8f9fa";
                        }}
                    >
                        <FaSort /> {sortOrder === "asc" ? "A-Z" : "Z-A"}
                    </button>
                </div>
            </div>

            {/* Stats Cards */}
            {/* <div className="stats-cards" style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                gap: "15px",
                marginBottom: "25px"
            }}>
                <div className="stat-card" style={{
                    padding: "20px",
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "12px",
                    color: "white",
                    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)"
                }}>
                    <div style={{ fontSize: "14px", opacity: 0.9 }}>Total Categories</div>
                    <div style={{ fontSize: "32px", fontWeight: "700" }}>{categories.length}</div>
                </div>
                <div className="stat-card" style={{
                    padding: "20px",
                    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                    borderRadius: "12px",
                    color: "white",
                    boxShadow: "0 4px 15px rgba(245, 87, 108, 0.3)"
                }}>
                    <div style={{ fontSize: "14px", opacity: 0.9 }}>Total Dishes</div>
                    <div style={{ fontSize: "32px", fontWeight: "700" }}>{dishes.length}</div>
                </div>
                <div className="stat-card" style={{
                    padding: "20px",
                    background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                    borderRadius: "12px",
                    color: "white",
                    boxShadow: "0 4px 15px rgba(79, 172, 254, 0.3)"
                }}>
                    <div style={{ fontSize: "14px", opacity: 0.9 }}>Avg. Dishes/Category</div>
                    <div style={{ fontSize: "32px", fontWeight: "700" }}>
                        {categories.length > 0 ? Math.round(dishes.length / categories.length) : 0}
                    </div>
                </div>
            </div> */}

            {/* Main Table */}
            {loading && (
                <div style={{
                    textAlign: "center",
                    padding: "60px",
                    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                    borderRadius: "15px",
                    margin: "20px 0"
                }}>
                    <div className="spinner" style={{
                        width: "50px",
                        height: "50px",
                        border: "5px solid #f3f3f3",
                        borderTop: "5px solid #e66d33",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                        margin: "0 auto 20px"
                    }}></div>
                    <p style={{
                        fontSize: "18px",
                        color: "#666",
                        fontWeight: "bold"
                    }}>Loading menu data...</p>
                </div>
            )}

            {error && !loading && (
                <div style={{
                    textAlign: "center",
                    padding: "40px",
                    background: "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)",
                    borderRadius: "15px",
                    margin: "20px 0",
                    animation: "shake 0.5s ease"
                }}>
                    <div style={{
                        color: "#d32f2f",
                        marginBottom: "20px",
                        fontSize: "18px",
                        fontWeight: "bold"
                    }}>
                        ⚠️ {error}
                    </div>
                    <button
                        className="btn-retry"
                        onClick={handleRetry}
                        style={{
                            padding: "12px 30px",
                            background: "linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)",
                            color: "white",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "16px",
                            fontWeight: "bold",
                            transition: "all 0.3s ease",
                            boxShadow: "0 4px 15px rgba(230, 109, 51, 0.3)"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = "translateY(-3px)";
                            e.target.style.boxShadow = "0 8px 25px rgba(230, 109, 51, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow = "0 4px 15px rgba(230, 109, 51, 0.3)";
                        }}
                    >
                        🔄 Retry
                    </button>
                </div>
            )}

            {!loading && !error && (
                <div className="table-wrapper" style={{
                    overflowX: "auto",
                    borderRadius: "16px",
                    background: "white",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    position: "relative"
                }}>
                    <table style={{
                        width: "100%",
                        borderCollapse: "separate",
                        borderSpacing: "0",
                        minWidth: "700px"
                    }}>
                        <thead style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 10
                        }}>
                            <tr style={{
                                background: "linear-gradient(135deg, #e66d33 0%, #e66d33 100%)"
                            }}>
                                <th style={{
                                    padding: "18px 16px",
                                    textAlign: "left",
                                    fontWeight: "600",
                                    color: "white",
                                    fontSize: "14px",
                                    borderBottom: "none",
                                    letterSpacing: "0.5px"
                                }}>
                                    S.No
                                </th>
                                <th style={{
                                    padding: "18px 16px",
                                    textAlign: "left",
                                    fontWeight: "600",
                                    color: "white",
                                    fontSize: "14px",
                                    borderBottom: "none",
                                    letterSpacing: "0.5px"
                                }}>
                                    Category / Dish
                                </th>
                                {/* <th style={{
                                    padding: "18px 16px",
                                    textAlign: "center",
                                    fontWeight: "600",
                                    color: "white",
                                    fontSize: "14px",
                                    borderBottom: "none",
                                    letterSpacing: "0.5px"
                                }}>
                                    Image
                                </th> */}
                                <th style={{
                                    padding: "18px 16px",
                                    textAlign: "center",
                                    fontWeight: "600",
                                    color: "white",
                                    fontSize: "14px",
                                    borderBottom: "none",
                                    letterSpacing: "0.5px"
                                }}>
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories && categories.length > 0 ? (
                                categories.map((category, index) => {
                                    const categoryDishes = getDishesByCategory(category.catageoryId);

                                    return (
                                        <React.Fragment key={category.catageoryId}>
                                            {/* Category Row */}
                                            <tr
                                                data-category-id={category.catageoryId}
                                                style={{
                                                    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                                                    borderBottom: "2px solid #dee2e6",
                                                    transition: "all 0.3s ease"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = "linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)";
                                                }}>
                                                <td style={{
                                                    padding: "16px 16px",
                                                    fontWeight: "700",
                                                    fontSize: "15px",
                                                    color: "#1a1a2e",
                                                    verticalAlign: "middle"
                                                }}>{index + 1}</td>
                                                <td style={{
                                                    padding: "12px 16px",
                                                    fontWeight: "600",
                                                    fontSize: "16px",
                                                    color: "#1a1a2e",
                                                    verticalAlign: "middle"
                                                }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        <div style={{
                                                            width: "8px",
                                                            height: "8px",
                                                            background: "linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)",
                                                            borderRadius: "50%",
                                                            animation: "pulse 2s infinite",
                                                            flexShrink: 0
                                                        }}></div>
                                                        <span>{category.catageoryName}</span>
                                                        <span style={{
                                                            fontSize: "12px",
                                                            color: "#666",
                                                            fontWeight: "400"
                                                        }}>
                                                            ({categoryDishes.length} dishes)
                                                        </span>
                                                    </div>
                                                </td>
                                                {/* <td style={{
                                                    padding: "12px 16px",
                                                    textAlign: "center",
                                                    verticalAlign: "middle"
                                                }}>
                                                    {renderImage(category.image, category.catageoryName)}
                                                </td> */}
                                                <td style={{
                                                    padding: "12px 16px",
                                                    textAlign: "center",
                                                    verticalAlign: "middle"
                                                }}>
                                                    <div style={{
                                                        display: "flex",
                                                        gap: "8px",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        flexWrap: "wrap"
                                                    }}>
                                                        <button
                                                            onClick={() => handleAddClick(category)}
                                                            className="btn-add-dish"
                                                            style={{
                                                                padding: "8px 14px",
                                                                background: "linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "6px",
                                                                cursor: "pointer",
                                                                fontSize: "12px",
                                                                fontWeight: "600",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                transition: "all 0.3s ease",
                                                                boxShadow: "0 2px 10px rgba(230, 109, 51, 0.2)"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.transform = "translateY(-2px)";
                                                                e.target.style.boxShadow = "0 4px 15px rgba(230, 109, 51, 0.3)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.transform = "translateY(0)";
                                                                e.target.style.boxShadow = "0 2px 10px rgba(230, 109, 51, 0.2)";
                                                            }}
                                                        >
                                                            <FaPlus size={11} /> Add Dish
                                                        </button>
                                                        <div style={{ display: "flex", gap: "8px" }}>
                                                            <FaEdit
                                                                onClick={() => handleEditCategoryClick(category)}
                                                                onMouseEnter={() => setHoveredEdit(`category-${category.catageoryId}`)}
                                                                onMouseLeave={() => setHoveredEdit(null)}
                                                                style={{
                                                                    fontSize: "18px",
                                                                    cursor: "pointer",
                                                                    color: hoveredEdit === `category-${category.catageoryId}` ? "#e66d33" : "#6c757d",
                                                                    transition: "all 0.3s ease",
                                                                    transform: hoveredEdit === `category-${category.catageoryId}` ? "scale(1.2)" : "scale(1)",
                                                                    padding: "4px"
                                                                }}
                                                            />
                                                            <FaTrash
                                                                onClick={() => handleDeleteCategory(category.catageoryId)}
                                                                onMouseEnter={() => setHoveredDelete(`category-${category.catageoryId}`)}
                                                                onMouseLeave={() => setHoveredDelete(null)}
                                                                style={{
                                                                    fontSize: "18px",
                                                                    cursor: "pointer",
                                                                    color: hoveredDelete === `category-${category.catageoryId}` ? "#dc3545" : "#6c757d",
                                                                    transition: "all 0.3s ease",
                                                                    transform: hoveredDelete === `category-${category.catageoryId}` ? "scale(1.2)" : "scale(1)",
                                                                    padding: "4px"
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                            {/* Dish Rows */}
                                            {categoryDishes.map((dish, dishIndex) => (
                                                <tr
                                                    key={dish.id}
                                                    data-dish-id={dish.id}
                                                    style={{
                                                        background: dishIndex % 2 === 0 ? "#ffffff" : "#fafafa",
                                                        borderBottom: dishIndex === categoryDishes.length - 1 ? "2px solid #dee2e6" : "1px solid #f0f0f0",
                                                        transition: "all 0.3s ease",
                                                        opacity: 1,
                                                        transform: "translateX(0)"
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background = "#f0f7ff";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background = dishIndex % 2 === 0 ? "#ffffff" : "#fafafa";
                                                    }}
                                                >
                                                    <td style={{
                                                        padding: "12px 16px",
                                                        color: "#999",
                                                        fontSize: "13px",
                                                        textAlign: "left",
                                                        verticalAlign: "middle",
                                                        paddingLeft: "32px"
                                                    }}>
                                                        {index + 1}.{dishIndex + 1}
                                                    </td>
                                                    <td style={{
                                                        padding: "10px 16px",
                                                        color: "#555",
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        verticalAlign: "middle"
                                                    }}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                            <span style={{
                                                                width: "6px",
                                                                height: "6px",
                                                                background: "linear-gradient(135deg, #f5576c 0%, #ff6b6b 100%)",
                                                                borderRadius: "50%",
                                                                flexShrink: 0
                                                            }}></span>
                                                            <span>{dish.name}</span>
                                                        </div>
                                                    </td>
                                                    {/* <td style={{
                                                        padding: "10px 16px",
                                                        textAlign: "center",
                                                        verticalAlign: "middle"
                                                    }}>
                                                        {renderImage(dish.image, dish.name)}
                                                    </td> */}
                                                    <td style={{
                                                        padding: "10px 16px",
                                                        textAlign: "center",
                                                        verticalAlign: "middle"
                                                    }}>
                                                        <div style={{
                                                            display: "flex",
                                                            gap: "15px",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}>
                                                            <FaEdit
                                                                onClick={() => handleEditDishClick(dish.id)}
                                                                onMouseEnter={() => setHoveredEdit(dish.id)}
                                                                onMouseLeave={() => setHoveredEdit(null)}
                                                                style={{
                                                                    fontSize: "17px",
                                                                    cursor: "pointer",
                                                                    color: hoveredEdit === dish.id ? "#e66d33" : "#6c757d",
                                                                    transition: "all 0.3s ease",
                                                                    transform: hoveredEdit === dish.id ? "scale(1.2)" : "scale(1)",
                                                                    padding: "4px"
                                                                }}
                                                            />
                                                            <FaTrash
                                                                onClick={() => handleDeleteDish(dish.id)}
                                                                onMouseEnter={() => setHoveredDelete(dish.id)}
                                                                onMouseLeave={() => setHoveredDelete(null)}
                                                                style={{
                                                                    fontSize: "17px",
                                                                    cursor: "pointer",
                                                                    color: hoveredDelete === dish.id ? "#dc3545" : "#6c757d",
                                                                    transition: "all 0.3s ease",
                                                                    transform: hoveredDelete === dish.id ? "scale(1.2)" : "scale(1)",
                                                                    padding: "4px"
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{
                                        textAlign: "center",
                                        padding: "60px",
                                        color: "#999",
                                        fontSize: "18px",
                                        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)"
                                    }}>
                                        <div style={{ marginBottom: "20px" }}>
                                            <div style={{
                                                width: "80px",
                                                height: "80px",
                                                margin: "0 auto 20px",
                                                background: "linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)",
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "white",
                                                fontSize: "30px",
                                                animation: "pulse 2s infinite"
                                            }}>
                                                🍽️
                                            </div>
                                        </div>
                                        No categories found. Add your first category!
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Add Category Modal */}
            <Modal
                isOpen={isQuickModal}
                onRequestClose={() => {
                    setIsQuickModal(false);
                    setQuickForm({ catageory: "", image: null });
                }}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        zIndex: 10000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(5px)'
                    },
                    content: {
                        position: 'relative',
                        margin: 'auto',
                        border: 'none',
                        background: '#fff',
                        overflow: 'auto',
                        borderRadius: '16px',
                        outline: 'none',
                        padding: '30px',
                        maxWidth: '440px',
                        width: '90%',
                        zIndex: 10001,
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                    }
                }}
            >
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => {
                            setIsQuickModal(false);
                            setQuickForm({ catageory: "", image: null });
                        }}
                        style={{
                            position: 'absolute',
                            top: '-10px',
                            right: '-10px',
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            color: '#999',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = '#333';
                            e.target.style.transform = 'rotate(90deg)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = '#999';
                            e.target.style.transform = 'rotate(0)';
                        }}
                    >
                        <FaTimes />
                    </button>

                    <h3 style={{
                        margin: '0 0 25px 0',
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#1a1a2e',
                        borderBottom: '2px solid #f0f0f0',
                        paddingBottom: '15px'
                    }}>
                        <FaPlus style={{ color: '#e66d33', marginRight: '10px' }} />
                        Add New Category
                    </h3>

                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ marginBottom: '18px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontSize: '14px',
                                color: '#555',
                                fontWeight: '600'
                            }}>
                                Category Name
                            </label>
                            <input
                                type="text"
                                name="catageory"
                                placeholder="Enter category name"
                                value={quickForm.catageory}
                                onChange={handleQuickChange}
                                style={{
                                    width: '100%',
                                    padding: '12px 15px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box',
                                    transition: 'all 0.3s ease',
                                    outline: 'none'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#e66d33';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#e0e0e0';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                        </div>

                        {/* <div style={{ marginBottom: '18px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontSize: '14px',
                                color: '#555',
                                fontWeight: '600'
                            }}>
                                Category Image
                            </label>
                            <div style={{
                                border: '2px dashed #e0e0e0',
                                borderRadius: '10px',
                                padding: '20px',
                                textAlign: 'center',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#e66d33';
                                    e.currentTarget.style.background = '#fff5f0';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#e0e0e0';
                                    e.currentTarget.style.background = 'transparent';
                                }}
                            >
                                <input
                                    type="file"
                                    name="image"
                                    onChange={handleQuickChange}
                                    accept="image/*"
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        fontSize: '14px'
                                    }}
                                />
                                {quickForm.image && (
                                    <div style={{
                                        marginTop: '10px',
                                        fontSize: '13px',
                                        color: '#28a745',
                                        fontWeight: '500'
                                    }}>
                                        ✅ {quickForm.image.name}
                                    </div>
                                )}
                            </div>
                        </div> */}
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px',
                        paddingTop: '20px',
                        borderTop: '2px solid #f0f0f0'
                    }}>
                        <button
                            onClick={() => {
                                setIsQuickModal(false);
                                setQuickForm({ catageory: "", image: null });
                            }}
                            style={{
                                padding: '10px 24px',
                                background: '#f8f9fa',
                                color: '#555',
                                border: '2px solid #e0e0e0',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = '#e9ecef';
                                e.target.style.borderColor = '#ced4da';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = '#f8f9fa';
                                e.target.style.borderColor = '#e0e0e0';
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleQuickSave}
                            disabled={isLoading}
                            style={{
                                padding: '10px 28px',
                                background: isLoading ? '#ccc' : 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                boxShadow: isLoading ? 'none' : '0 4px 15px rgba(230, 109, 51, 0.3)'
                            }}
                            onMouseEnter={(e) => {
                                if (!isLoading) {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 6px 25px rgba(230, 109, 51, 0.4)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isLoading) {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(230, 109, 51, 0.3)';
                                }
                            }}
                        >
                            {isLoading ? (
                                <>
                                    <FaSpinner style={{
                                        animation: 'spin 1s linear infinite',
                                        fontSize: '14px'
                                    }} />
                                    Adding...
                                </>
                            ) : 'Add Category'}
                        </button>
                    </div>
                </div>
            </Modal>

            {/* Add Dish Modal */}
            <Modal
                isOpen={isDetailModal}
                onRequestClose={() => {
                    setIsDetailModal(false);
                    setDetailForm({ id: "", catageoryId: "", dishName: "", image: null });
                    setSelectedCategoryName("");
                }}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        zIndex: 10000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(5px)'
                    },
                    content: {
                        position: 'relative',
                        margin: 'auto',
                        border: 'none',
                        background: '#fff',
                        overflow: 'auto',
                        borderRadius: '16px',
                        outline: 'none',
                        padding: '30px',
                        maxWidth: '440px',
                        width: '90%',
                        zIndex: 10001,
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                    }
                }}
            >
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => {
                            setIsDetailModal(false);
                            setDetailForm({ id: "", catageoryId: "", dishName: "", image: null });
                            setSelectedCategoryName("");
                        }}
                        style={{
                            position: 'absolute',
                            top: '-10px',
                            right: '-10px',
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            color: '#999',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = '#333';
                            e.target.style.transform = 'rotate(90deg)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = '#999';
                            e.target.style.transform = 'rotate(0)';
                        }}
                    >
                        <FaTimes />
                    </button>

                    <h3 style={{
                        margin: '0 0 25px 0',
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#1a1a2e',
                        borderBottom: '2px solid #f0f0f0',
                        paddingBottom: '15px'
                    }}>
                        <FaPlus style={{ color: '#e66d33', marginRight: '10px' }} />
                        Add New Dish
                    </h3>

                    {selectedCategoryName && (
                        <div style={{
                            marginBottom: '20px',
                            padding: '12px 16px',
                            background: '#f0f7ff',
                            borderRadius: '8px',
                            border: '1px solid #d4e4ff',
                            fontSize: '14px',
                            color: '#555'
                        }}>
                            <strong style={{ color: '#1a1a2e' }}>Category:</strong> {selectedCategoryName}
                        </div>
                    )}

                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ marginBottom: '18px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontSize: '14px',
                                color: '#555',
                                fontWeight: '600'
                            }}>
                                Dish Name
                            </label>
                            <input
                                type="text"
                                name="dishName"
                                placeholder="Enter dish name"
                                value={detailForm.dishName}
                                onChange={handleDetailChange}
                                style={{
                                    width: '100%',
                                    padding: '12px 15px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box',
                                    transition: 'all 0.3s ease',
                                    outline: 'none'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#e66d33';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#e0e0e0';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                        </div>

                        {/* <div style={{ marginBottom: '18px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontSize: '14px',
                                color: '#555',
                                fontWeight: '600'
                            }}>
                                Dish Image
                            </label>
                            <div style={{
                                border: '2px dashed #e0e0e0',
                                borderRadius: '10px',
                                padding: '20px',
                                textAlign: 'center',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#e66d33';
                                    e.currentTarget.style.background = '#fff5f0';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#e0e0e0';
                                    e.currentTarget.style.background = 'transparent';
                                }}
                            >
                                <input
                                    type="file"
                                    name="image"
                                    onChange={handleDetailChange}
                                    accept="image/*"
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        fontSize: '14px'
                                    }}
                                />
                                {detailForm.image && (
                                    <div style={{
                                        marginTop: '10px',
                                        fontSize: '13px',
                                        color: '#28a745',
                                        fontWeight: '500'
                                    }}>
                                        ✅ {detailForm.image.name}
                                    </div>
                                )}
                            </div>
                        </div> */}
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px',
                        paddingTop: '20px',
                        borderTop: '2px solid #f0f0f0'
                    }}>
                        <button
                            onClick={() => {
                                setIsDetailModal(false);
                                setDetailForm({ id: "", catageoryId: "", dishName: "", image: null });
                                setSelectedCategoryName("");
                            }}
                            style={{
                                padding: '10px 24px',
                                background: '#f8f9fa',
                                color: '#555',
                                border: '2px solid #e0e0e0',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = '#e9ecef';
                                e.target.style.borderColor = '#ced4da';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = '#f8f9fa';
                                e.target.style.borderColor = '#e0e0e0';
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleDetailSave}
                            disabled={isSaving}
                            style={{
                                padding: '10px 28px',
                                background: isSaving ? '#ccc' : 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: isSaving ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                boxShadow: isSaving ? 'none' : '0 4px 15px rgba(230, 109, 51, 0.3)'
                            }}
                            onMouseEnter={(e) => {
                                if (!isSaving) {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 6px 25px rgba(230, 109, 51, 0.4)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isSaving) {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(230, 109, 51, 0.3)';
                                }
                            }}
                        >
                            {isSaving ? (
                                <>
                                    <FaSpinner style={{
                                        animation: 'spin 1s linear infinite',
                                        fontSize: '14px'
                                    }} />
                                    Saving...
                                </>
                            ) : 'Add Dish'}
                        </button>
                    </div>
                </div>
            </Modal>

            {/* Edit Category Modal */}
            <Modal
                isOpen={isEditCategoryModal}
                onRequestClose={() => {
                    setIsEditCategoryModal(false);
                    setEditCategoryForm({ catageoryId: "", catageoryName: "", image: null, currentImage: "" });
                }}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        zIndex: 10000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(5px)'
                    },
                    content: {
                        position: 'relative',
                        margin: 'auto',
                        border: 'none',
                        background: '#fff',
                        overflow: 'auto',
                        borderRadius: '16px',
                        outline: 'none',
                        padding: '30px',
                        maxWidth: '440px',
                        width: '90%',
                        zIndex: 10001,
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                    }
                }}
            >
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => {
                            setIsEditCategoryModal(false);
                            setEditCategoryForm({ catageoryId: "", catageoryName: "", image: null, currentImage: "" });
                        }}
                        style={{
                            position: 'absolute',
                            top: '-10px',
                            right: '-10px',
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            color: '#999',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = '#333';
                            e.target.style.transform = 'rotate(90deg)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = '#999';
                            e.target.style.transform = 'rotate(0)';
                        }}
                    >
                        <FaTimes />
                    </button>

                    <h3 style={{
                        margin: '0 0 25px 0',
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#1a1a2e',
                        borderBottom: '2px solid #f0f0f0',
                        paddingBottom: '15px'
                    }}>
                        <FaEdit style={{ color: '#e66d33', marginRight: '10px' }} />
                        Edit Category
                    </h3>

                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ marginBottom: '18px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontSize: '14px',
                                color: '#555',
                                fontWeight: '600'
                            }}>
                                Category Name
                            </label>
                            <input
                                type="text"
                                name="catageoryName"
                                placeholder="Enter category name"
                                value={editCategoryForm.catageoryName}
                                onChange={handleEditCategoryChange}
                                style={{
                                    width: '100%',
                                    padding: '12px 15px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box',
                                    transition: 'all 0.3s ease',
                                    outline: 'none'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#e66d33';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#e0e0e0';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                        </div>

                        <div style={{ marginBottom: '18px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontSize: '14px',
                                color: '#555',
                                fontWeight: '600'
                            }}>
                                Category Image
                            </label>

                            {editCategoryForm.currentImage && (
                                <div style={{
                                    marginBottom: '12px',
                                    padding: '12px',
                                    background: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef'
                                }}>
                                    <div style={{
                                        fontSize: '12px',
                                        color: '#666',
                                        marginBottom: '8px'
                                    }}>
                                        Current Image:
                                    </div>
                                    <img
                                        src={getValidImageUrl(editCategoryForm.currentImage)}
                                        alt="Current"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            objectFit: 'cover',
                                            borderRadius: '8px',
                                            border: '2px solid #e0e0e0'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.parentElement.innerHTML = `
                                                <div style="width: 60px; height: 60px; background: #6c757d; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: white; font-size: 11px; font-weight: 600;">
                                                    No Image
                                                </div>
                                            `;
                                        }}
                                    />
                                </div>
                            )}

                            <div style={{
                                border: '2px dashed #e0e0e0',
                                borderRadius: '10px',
                                padding: '20px',
                                textAlign: 'center',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#e66d33';
                                    e.currentTarget.style.background = '#fff5f0';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#e0e0e0';
                                    e.currentTarget.style.background = 'transparent';
                                }}
                            >
                                <input
                                    type="file"
                                    name="image"
                                    onChange={handleEditCategoryChange}
                                    accept="image/*"
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        fontSize: '14px'
                                    }}
                                />
                                {editCategoryForm.image && (
                                    <div style={{
                                        marginTop: '10px',
                                        fontSize: '13px',
                                        color: '#28a745',
                                        fontWeight: '500'
                                    }}>
                                        ✅ {editCategoryForm.image.name}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px',
                        paddingTop: '20px',
                        borderTop: '2px solid #f0f0f0'
                    }}>
                        <button
                            onClick={() => {
                                setIsEditCategoryModal(false);
                                setEditCategoryForm({ catageoryId: "", catageoryName: "", image: null, currentImage: "" });
                            }}
                            style={{
                                padding: '10px 24px',
                                background: '#f8f9fa',
                                color: '#555',
                                border: '2px solid #e0e0e0',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = '#e9ecef';
                                e.target.style.borderColor = '#ced4da';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = '#f8f9fa';
                                e.target.style.borderColor = '#e0e0e0';
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleUpdateCategory}
                            disabled={isLoading}
                            style={{
                                padding: '10px 28px',
                                background: isLoading ? '#ccc' : 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                boxShadow: isLoading ? 'none' : '0 4px 15px rgba(230, 109, 51, 0.3)'
                            }}
                            onMouseEnter={(e) => {
                                if (!isLoading) {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 6px 25px rgba(230, 109, 51, 0.4)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isLoading) {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(230, 109, 51, 0.3)';
                                }
                            }}
                        >
                            {isLoading ? (
                                <>
                                    <FaSpinner style={{
                                        animation: 'spin 1s linear infinite',
                                        fontSize: '14px'
                                    }} />
                                    Updating...
                                </>
                            ) : 'Update Category'}
                        </button>
                    </div>
                </div>
            </Modal>

            {/* Edit Dish Modal */}
            <Modal
                isOpen={isEditDishModal}
                onRequestClose={() => {
                    setIsEditDishModal(false);
                    setEditDishForm({ id: "", name: "", image: null, currentImage: "", catageoryId: "" });
                }}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        zIndex: 10000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backdropFilter: 'blur(5px)'
                    },
                    content: {
                        position: 'relative',
                        margin: 'auto',
                        border: 'none',
                        background: '#fff',
                        overflow: 'auto',
                        borderRadius: '16px',
                        outline: 'none',
                        padding: '30px',
                        maxWidth: '440px',
                        width: '90%',
                        zIndex: 10001,
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                    }
                }}
            >
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => {
                            setIsEditDishModal(false);
                            setEditDishForm({ id: "", name: "", image: null, currentImage: "", catageoryId: "" });
                        }}
                        style={{
                            position: 'absolute',
                            top: '-10px',
                            right: '-10px',
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            color: '#999',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = '#333';
                            e.target.style.transform = 'rotate(90deg)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = '#999';
                            e.target.style.transform = 'rotate(0)';
                        }}
                    >
                        <FaTimes />
                    </button>

                    <h3 style={{
                        margin: '0 0 25px 0',
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#1a1a2e',
                        borderBottom: '2px solid #f0f0f0',
                        paddingBottom: '15px'
                    }}>
                        <FaEdit style={{ color: '#e66d33', marginRight: '10px' }} />
                        Edit Dish
                    </h3>

                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ marginBottom: '18px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontSize: '14px',
                                color: '#555',
                                fontWeight: '600'
                            }}>
                                Dish Name
                            </label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter dish name"
                                value={editDishForm.name}
                                onChange={handleEditDishChange}
                                style={{
                                    width: '100%',
                                    padding: '12px 15px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    boxSizing: 'border-box',
                                    transition: 'all 0.3s ease',
                                    outline: 'none'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#e66d33';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#e0e0e0';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                        </div>

                        <div style={{ marginBottom: '18px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontSize: '14px',
                                color: '#555',
                                fontWeight: '600'
                            }}>
                                Dish Image
                            </label>

                            {editDishForm.currentImage && (
                                <div style={{
                                    marginBottom: '12px',
                                    padding: '12px',
                                    background: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e9ecef'
                                }}>
                                    <div style={{
                                        fontSize: '12px',
                                        color: '#666',
                                        marginBottom: '8px'
                                    }}>
                                        Current Image:
                                    </div>
                                    <img
                                        src={getValidImageUrl(editDishForm.currentImage)}
                                        alt="Current"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            objectFit: 'cover',
                                            borderRadius: '8px',
                                            border: '2px solid #e0e0e0'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.parentElement.innerHTML = `
                                                <div style="width: 60px; height: 60px; background: #6c757d; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: white; font-size: 11px; font-weight: 600;">
                                                    No Image
                                                </div>
                                            `;
                                        }}
                                    />
                                </div>
                            )}

                            <div style={{
                                border: '2px dashed #e0e0e0',
                                borderRadius: '10px',
                                padding: '20px',
                                textAlign: 'center',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#e66d33';
                                    e.currentTarget.style.background = '#fff5f0';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#e0e0e0';
                                    e.currentTarget.style.background = 'transparent';
                                }}
                            >
                                <input
                                    type="file"
                                    name="image"
                                    onChange={handleEditDishChange}
                                    accept="image/*"
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        fontSize: '14px'
                                    }}
                                />
                                {editDishForm.image && (
                                    <div style={{
                                        marginTop: '10px',
                                        fontSize: '13px',
                                        color: '#28a745',
                                        fontWeight: '500'
                                    }}>
                                        ✅ {editDishForm.image.name}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px',
                        paddingTop: '20px',
                        borderTop: '2px solid #f0f0f0'
                    }}>
                        <button
                            onClick={() => {
                                setIsEditDishModal(false);
                                setEditDishForm({ id: "", name: "", image: null, currentImage: "", catageoryId: "" });
                            }}
                            style={{
                                padding: '10px 24px',
                                background: '#f8f9fa',
                                color: '#555',
                                border: '2px solid #e0e0e0',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = '#e9ecef';
                                e.target.style.borderColor = '#ced4da';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = '#f8f9fa';
                                e.target.style.borderColor = '#e0e0e0';
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleUpdateDish}
                            disabled={isSaving}
                            style={{
                                padding: '10px 28px',
                                background: isSaving ? '#ccc' : 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: isSaving ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                transition: 'all 0.2s',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                boxShadow: isSaving ? 'none' : '0 4px 15px rgba(230, 109, 51, 0.3)'
                            }}
                            onMouseEnter={(e) => {
                                if (!isSaving) {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 6px 25px rgba(230, 109, 51, 0.4)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isSaving) {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(230, 109, 51, 0.3)';
                                }
                            }}
                        >
                            {isSaving ? (
                                <>
                                    <FaSpinner style={{
                                        animation: 'spin 1s linear infinite',
                                        fontSize: '14px'
                                    }} />
                                    Updating...
                                </>
                            ) : 'Update Dish'}
                        </button>
                    </div>
                </div>
            </Modal>

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                
                @keyframes slideUp {
                    from { 
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to { 
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
                }
                
                @keyframes shake {
                    0%, 100% { transform: translateX(0); }
                    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
                    20%, 40%, 60%, 80% { transform: translateX(5px); }
                }
                
                @keyframes letterAnim {
                    0% { opacity: 0; transform: translateY(30px); }
                    100% { opacity: 1; transform: translateY(0); }
                }

                @keyframes progress {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(250%); }
                }
                
                /* Custom scrollbar */
                ::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }
                
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 10px;
                }
                
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 10px;
                }
                
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }
                
                /* For Firefox */
                * {
                    scrollbar-width: thin;
                    scrollbar-color: #e66d33 #f1f1f1;
                }

                /* Responsive Design */
                @media (max-width: 992px) {
                    .food-menu-container {
                        padding: 15px;
                    }
                    
                    .menu-header {
                        flex-direction: column;
                        align-items: stretch;
                        text-align: center;
                    }
                    
                    .header-right {
                        justify-content: center;
                    }
                    
                    .stats-cards {
                        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
                    }
                }

                @media (max-width: 768px) {
                    .food-menu-container {
                        margin-top: 80px;
                        padding: 10px;
                    }
                    
                    .menu-header h1 {
                        font-size: 22px;
                    }
                    
                    .search-filter-bar {
                        flex-direction: column;
                        align-items: stretch;
                    }
                    
                    .filter-wrapper {
                        flex-wrap: wrap;
                        justify-content: center;
                    }
                    
                    .table-wrapper {
                        overflow-x: auto;
                    }
                    
                    table {
                        font-size: 13px;
                    }
                    
                    th, td {
                        padding: 10px 8px !important;
                    }
                    
                    .stats-cards {
                        grid-template-columns: 1fr 1fr;
                    }
                    
                    .stat-card {
                        padding: 15px !important;
                    }
                    
                    .stat-card div:last-child {
                        font-size: 24px !important;
                    }
                }

                @media (max-width: 480px) {
                    .food-menu-container {
                        margin-top: 70px;
                        padding: 8px;
                    }
                    
                    .menu-header {
                        padding: 15px !important;
                    }
                    
                    .menu-header h1 {
                        font-size: 18px;
                    }
                    
                    .header-right button {
                        padding: 8px 16px !important;
                        font-size: 13px !important;
                    }
                    
                    .stats-cards {
                        grid-template-columns: 1fr;
                        gap: 10px;
                    }
                    
                    .stat-card {
                        padding: 12px !important;
                    }
                    
                    .stat-card div:last-child {
                        font-size: 20px !important;
                    }
                    
                    table {
                        font-size: 12px;
                        min-width: 500px;
                    }
                    
                    th, td {
                        padding: 8px 6px !important;
                    }
                    
                    .modal-content {
                        padding: 20px !important;
                        max-width: 95% !important;
                    }
                    
                    .modal-content h3 {
                        font-size: 18px !important;
                    }
                    
                    .btn-add-dish {
                        padding: 6px 10px !important;
                        font-size: 11px !important;
                    }
                }

                /* Smooth transitions for all interactive elements */
                button, input, select, .stat-card, .table-wrapper {
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }

                /* Hover effects for cards */
                .stat-card {
                    transition: all 0.3s ease;
                }
                
                .stat-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 30px rgba(0,0,0,0.15);
                }

                /* Table row animation */
                tbody tr {
                    animation: fadeIn 0.3s ease;
                }

                /* Modal animations */
                .ReactModal__Overlay {
                    animation: fadeIn 0.3s ease;
                }
                
                .ReactModal__Content {
                    animation: slideUp 0.3s ease;
                }
            `}</style>
        </div>
    );
}